import React from "react"
import Dialog from "@material-ui/core/Dialog"
import Button from "@material-ui/core/Button"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import history from "tools/history"
import OnboardingStepper from "./OnboardingStepper"
import "./FreeTrialWelcomeModal.scss"
import { TRIAL_INCLUDED_CREDITS } from "constants/plans"

// Static onboarding stepper shown to a free-trial (Starter) user landing in the
// platform for the first time. Steps 1-3 are already done, payment is skipped on
// the free path, and step 5 (in the platform) is the active state.
const STEPS = [
  { label: "Select plan", state: "done" },
  { label: "Set up account", state: "done" },
  { label: "Confirm email", state: "done" },
  { label: "Payment & billing – skipped on free", state: "skipped" },
  { label: "Into the platform", state: "active" },
]

/**
 * Free-trial welcome modal. Shown once when a Starter/free-trial user reaches the
 * platform via the deep link (/settings?tab=billing&plan=starter) right after email
 * verification. No payment was collected on this path.
 */
const FreeTrialWelcomeModal = ({ open, onClose, credits = TRIAL_INCLUDED_CREDITS }) => {
  const runFirstApplication = () => {
    onClose()
    history.push("/create-applicant")
  }

  const explorePlatform = () => {
    onClose()
    history.push("/dashboard")
  }

  // Only the X button (or an explicit action) closes this modal — backdrop
  // clicks are ignored so it isn't dismissed by accident.
  const handleDialogClose = (e, reason) => {
    if (reason === "backdropClick") return
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: "ftw-dialog-paper" }}
    >
      <div className="ftw-content">
        <IconButton className="ftw-close" aria-label="Close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <OnboardingStepper steps={STEPS} />

        <h2 className="ftw-title">Welcome to ROX</h2>
        <p className="ftw-subtitle">
          You&apos;re on a free trial with {credits} credits to run reports and explore the platform.
        </p>

        <Button fullWidth className="ftw-cta" onClick={runFirstApplication}>
          Run your first application
        </Button>

        <div
          className="ftw-secondary"
          role="button"
          tabIndex={0}
          onClick={explorePlatform}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); explorePlatform() } }}
        >
          Explore the platform first
        </div>
      </div>
    </Dialog>
  )
}

export default FreeTrialWelcomeModal
